import React from 'react';
import './services.css';

const whyChooseItems = [
  {
    icon: '/services/pool.JPG',
    title: 'Indoor Swimming Pool',
    desc: "Enjoy a private swim in the villa's exclusive indoor pool"
  },
  {
    icon: '/services/theatre.JPG',
    title: 'Personal Movie Theatre',
    desc: 'Relax in a home theatre with 6 recliner seats'
  },
  {
    icon: '/services/bar.JPG',
    title: 'Modern Amenities',
    desc: 'Fully equipped modular kitchen, bar, and entertainment options'
  },
  {
    icon: '/services/miniGoa.jpg',
    title: 'Prime Location',
    desc: '75 km from Dalhousie, 86 km from Dharamshala',
    isMap: true
  },
  {
    icon: '/services/exclusiveExperience.JPG',
    title: 'Exclusive Experience',
    desc: 'A cozy yet luxurious property with a homely feel'
  },
  {
    icon: '/services/miniGoa.jpg',
    title: 'Nearby Attractions',
    desc: 'Mini Goa, Pandava Mandir, Oldest Shani Dev mandir, Damn Area'
  }
];

const Services = () => (
  <>
    {/* Page Header for SEO and Google Ads Compliance */}
    <header className="page-header" style={{
      background: 'linear-gradient(135deg, #561314 0%, #8B0000 100%)',
      color: 'white',
      textAlign: 'center',
      padding: '2rem 1rem',
      marginBottom: '0'
    }}>
      <h1 style={{
        fontSize: '2.5rem',
        margin: '0 0 1rem 0',
        fontWeight: '600',
        textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
      }}>
        Our Services - Premium Villa Accommodation in Pathankot
      </h1>
      <p style={{
        fontSize: '1.2rem',
        margin: '0',
        maxWidth: '800px',
        marginLeft: 'auto',
        marginRight: 'auto',
        lineHeight: '1.6',
        opacity: '0.95'
      }}>
        Experience luxury villa services including indoor swimming pool, personal movie theatre, and world-class amenities. 
        Perfect for family gatherings, parties, and memorable stays in the heart of Pathankot.
      </p>
    </header>
    
    <section className="why-choose-section">
      <h2 className="why-choose-title">Our Services</h2>
      <p className="services-desc" style={{textAlign: 'center', marginBottom: '2rem'}}>We provide premium hotel services to make your stay unforgettable.</p>
      <div className="why-choose-grid">
        {whyChooseItems.map((item, index) => (
          <div key={index} className="why-choose-item">
            <div className="why-choose-icon">
              <img src={item.icon} alt={item.title} />
            </div>
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  </>
);

export default Services;